export function App({children:a,location:b}){return a}